document.addEventListener("DOMContentLoaded", function () {
    const ua = navigator.userAgent || navigator.platform || "unknown";
    const body = document.body;

    if (/iPad|iPhone|iPod/.test(ua)) {
      body.classList.add("mac-os");
    }
    else if (/Macintosh|Mac OS X/.test(ua)) {
      body.classList.add("mac-os");
    }
    else if (/Win32|Win64|Windows/.test(ua)) {
      body.classList.add("win-os");
    }
    else if (/Android/.test(ua)) {
      body.classList.add("win-os");
    }
  });


// mobile menu js 

$(".header__mobi-left-menu").on("click", function () {
    $(this).toggleClass("active");
    $(".header__mobi-menu").toggleClass('active');
    $("body").toggleClass("mobile__menu-open");
})


// header start



function headerSticky() {
    let lastScrollTop = 0;
    const header = document.querySelector('.header');
    if (!header) return;
    window.addEventListener('scroll', function () {
        const currentScroll = window.scrollY;

        if (currentScroll > 100) header.classList.add('header__inner_hove-active');
        else header.classList.remove('header__inner_hove-active');

        if (currentScroll === 0) header.style.transform = 'translateY(0)';
        else if (currentScroll < lastScrollTop) header.style.transform = 'translateY(0)';
        else header.style.transform = 'translateY(-100%)';
        lastScrollTop = currentScroll;
    });
}
headerSticky();



// header end


if($('.nutritional-image-slider').length >0 ){
    $('.nutritional-image-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots:true,
    });
}


// product-card mobile slider start


if ($(Window).width() < 768) {
    $('.shop__wrap').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        initialSlide: 1,
    });
}


// product-card mobile slider end




// instagram start



$(".instagram__items").slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    cssEase: "linear",
    variableWidth: true,
    arrows: false,
    pauseOnHover: false,
});

if (document.querySelector('.hero__btn')) {
  setTimeout(function () {
    document.querySelector('.hero__btn').classList.add('move');
  }, 1000);
}

// instagram end


$(document).ready(function () {
    let $imgs = $('.footer__logo img');
    let index = 0;
    let duration = 500;
    let fadeSpeed = 1000;

    $imgs.eq(index).addClass('active').fadeIn(fadeSpeed);

    setInterval(function () {
        let $current = $imgs.eq(index);
        index = (index + 1) % $imgs.length;
        let $next = $imgs.eq(index);

        $current.removeClass('active').fadeOut(fadeSpeed);
        $next.addClass('active').fadeIn(fadeSpeed);
    }, duration);
});


// Start Slick Slider Testimonial Home page

if ($(Window).width() < 768) {
    $(".testimonial__items").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
    });
}

// End Slick Slider Testimonial Home page

// Start Product Capming Variyent Slick Slider Home Page
if ($(Window).width() < 768) {
    $(".product-camping__variyent").slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 5000,
        cssEase: "linear",
        variableWidth: true,
        arrows: false,
        pauseOnHover: false,
    });
}
// End Product Capming Variyent Slick Slider Home Page


// Start Slick Slider Product Camping Home page

if ($(Window).width() < 768) {
    $(".product-camping__items").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        adaptiveHeight: true,
    });
}

// End Slick Slider Product Camping Home page


// cart slider start

$('.cart-drawer__slider-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    variableWidth:true,
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
    ]
});

$('.cart-drawer__slider-left').click(function () {
    $(this).parent().parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.cart-drawer__slider-right').click(function () {
    $(this).parent().parent().parent().find('.slick-slider').slick('slickNext');
});


// cart slider end










// cart show start


$(".header__right-cart").on('click', function () {
    $('body').addClass('cart-open');
})

$(document).on('click', '.cart-drawer__close, .overlay', function () {
$('body').removeClass('cart-open');
})


// cart show end



// compare-tab start



document.addEventListener("DOMContentLoaded", () => {
    const tabs = document.querySelectorAll(".compare__tab-item");
    const tables = document.querySelectorAll(".compare__table");

    function showTable(type) {
        tables.forEach(table => {
            if (table.dataset.type === type) {
                table.classList.add("active");
            } else {
                table.classList.remove("active");
            }
        });
    }

    tabs.forEach(tab => {
        tab.addEventListener("click", () => {
            const type = tab.dataset.type;

            // active class change on tab
            tabs.forEach(t => t.classList.remove("active"));
            tab.classList.add("active");

            // show the matching table
            showTable(type);
        });
    });

    // default show first one
    const firstType = tabs[0]?.dataset.type;
    if (firstType) showTable(firstType);
});


// compare-tab end


// Start Footer Image Up Down Animation



/*
$(function () {
    const $s = $('.footer__cartoon-shap'),
        $e = $('.footer__cartoon-eye'),
        $f = $('.footer__img');
    let loop;
    const pos = () => $(window).width() < 768 ? { s: '85%', e: '15%' } : { s: '89%', e: '15%' };
    const runAnimationCycle = () => {
        const { e } = pos();
        $e.css('transition', '1s ease-in-out').css('left', '33%');
        setTimeout(() => $e.css('left', '43%'), 1000);
        setTimeout(() => $s.css('transition', '1s ease-in-out').css('top', '85%'), 2000);
        setTimeout(() => $s.css('top', e), 4000);
        setTimeout(() => $e.css('left', '33%'), 5000);
        setTimeout(() => $e.css('left', '43%'), 6000);
    };
    const animate = () => {
        if (loop) return;
        $s.css('transition', '1s ease-in-out').css('top', pos().e);
        runAnimationCycle();
        loop = setInterval(runAnimationCycle, 6000);
    };
    const stop = () => {
        clearInterval(loop);
        loop = null;
        $s.css('top', '85%');
        $e.css('left', '43%');
    };
    new IntersectionObserver(entries => entries.forEach(e => e.isIntersecting ? animate() : stop()), { threshold: 0.6 }).observe($f.get(0));
    $(window).on('resize', stop);
});
*/




// End Footer Image Up Down Animation




// scroll animation start

const elements = document.querySelectorAll(".scroll-animation");
function checkScroll() {
    elements.forEach(el => {
        const rect = el.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.85) {
            el.classList.add("visible");
        }
    });
}
window.addEventListener("scroll", checkScroll);
checkScroll();



// scroll animation end



// product slider start



$('.product__big-items').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    asNavFor: '.product__small-items',
    responsive: [
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        },
    ]
});
$('.product__small-items').slick({
    slidesToShow: 6,
    slidesToScroll: 1,
    asNavFor: '.product__big-items',
    centerMode: false,
    focusOnSelect: true,
    arrows: false,
});

$('.product__left-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickPrev');
});
$('.product__right-arrow').click(function () {
    $(this).parent().parent().find('.slick-slider').slick('slickNext');
});




// product slider end





// product-dropdown start


$(document).ready(function () {
    $(document).on('click', '.product__subs-dropdown-selected', function (e) {
        e.stopPropagation();
        $('.product__subs-dropdown-options').not($(this).next()).removeClass('show');
        $(this).toggleClass('active').next('.product__subs-dropdown-options').toggleClass('show');
    });
});




// product-dropdown end



// accordion start


$(".accordion-item__title").click(function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass("active");
        $(this).next(".accordion-item__content").slideUp();
    } else {
        $(".accordion-item__content").slideUp();
        $(".accordion-item__title").removeClass("active");
        $(this).addClass("active");
        $(this).next(".accordion-item__content").slideDown();
    }
})

// accordion end



// collection-product start


if ($(Window).width() < 768) {
    $('.collection-product__items').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
    });
}


// collection-product end


// Shop Page Text With Icon Slider start

if ($(Window).width() < 768) {
    $('.shop-range__icons').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true
    });
}

// Shop Page Text With Icon Slider end


$('.product-card__variant').on('change', function() {
    var productId = $(this).parent().find('.product-card__variant:checked').val();
    var available = $(this).parent().find('.product-card__variant:checked').attr('available');
    $(this).parent().parent().find('.product-card__atc-variant').val(productId);
});


$('a[href^="#"]').on('click', function (e) {
  var target = $(this.getAttribute('href'));
  var headerOffset = 0; // change this

  if (target.length) {
    e.preventDefault();

    $('html, body').animate(
      {
        scrollTop: target.offset().top - headerOffset
      },
      600
    );
  }
});
